import React from 'react'

export const VehicleIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.6 9.33333H16.2C16.68 9.33333 17 9 17 8.5V6C17 5.25 16.44 4.58333 15.8 4.41667C14.36 4 12.2 3.5 12.2 3.5C12.2 3.5 11.16 2.33333 10.44 1.58333C10.04 1.25 9.56 1 9 1H3.4C2.92 1 2.52 1.33333 2.28 1.75L1.16 4.16667C1.05406 4.48852 1 4.82642 1 5.16667V8.5C1 9 1.32 9.33333 1.8 9.33333H3.4M14.6 9.33333C14.6 10.2538 13.8837 11 13 11C12.1163 11 11.4 10.2538 11.4 9.33333M14.6 9.33333C14.6 8.41286 13.8837 7.66667 13 7.66667C12.1163 7.66667 11.4 8.41286 11.4 9.33333M3.4 9.33333C3.4 10.2538 4.11634 11 5 11C5.88366 11 6.6 10.2538 6.6 9.33333M3.4 9.33333C3.4 8.41286 4.11634 7.66667 5 7.66667C5.88366 7.66667 6.6 8.41286 6.6 9.33333M6.6 9.33333H11.4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
